<template>
  <div>
    <window title="Autocomplete">
      <div>
        <div class="field">
          <label class="label">Search location</label>
          <GmapAutocomplete class="input" @place_changed="setPlace">
          </GmapAutocomplete>
        </div>
        <div class="field">
          <button @click="usePlace">Keep pin on map</button>
        </div>
        <GmapMap style="height: 500px;"
          :center="{
            lat: autocompleteLat,
            lng: autocompleteLng
            }"
          :options="{
            zoom: autocompleteZoom,
            gestureHandling: 'cooperative'
          }">
          <GmapMarker v-for="(marker, index) in markers" :key="index" :position="marker.position" />
          <GmapMarker v-if="this.place" label="★" :position="{
          lat: this.place.geometry.location.lat(),
          lng: this.place.geometry.location.lng(),
        }" />
        </GmapMap>
      </div>
    </window>

    <window title="Click twice on the map!">
      <GmapMap style="height: 500px;" :options="{gestureHandling: 'cooperative'}" :zoom="2"
        :center="center2" ref="map" @click="clicked"
      >
        <GmapMarker v-if="start" :position="start.latLng" label="S" />
        <GmapMarker v-if="end" :position="end.latLng" label="E" />
        <GmapPolyline v-if="curvedPath" :path="curvedPath" />
      </GmapMap>
    </window>
  </div>
</template>

<script>
import Vue from 'vue';
import { range } from 'lodash';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDH2YAu-XzZ52eE26ZW5zG0TIgmyTJYDqs',
    libraries: 'places',
  },
});

export default {
  data() {
    return {
      google: VueGoogleMaps.gmapApi,
      markers: [],
      markersgenerate: [],
      place: null,
      start: null,
      autocompleteLat: 0,
      autocompleteLng: 0,
      autocompleteZoom: 3,
      end: null,
      center: { lat: 0, lng: 0 },
      center2: { lat: 0, lng: 0 },
    };
  },
  computed: {
    curvedPath() {
      if (this.start && this.end) {
        return range(100)
          .map((i) => {
            const tick = i / 99;
            /* Bezier curve -- set up the control points */
            const dlat = this.end.latLng.lat() - this.start.latLng.lat();
            const dlng = this.end.latLng.lng() - this.start.latLng.lng();
            const cp1 = {
              lat: this.start.latLng.lat() + (0.33 * dlat) + (0.33 * dlng),
              lng: this.start.latLng.lng() + -(0.33 * dlat) + (0.33 * dlng),
            };
            const cp2 = {
              lat: this.end.latLng.lat() + -(0.33 * dlat) + (0.33 * dlng),
              lng: this.end.latLng.lng() + -(0.33 * dlat) + -(0.33 * dlng),
            };
            /* Bezier curve formula */
            return {
              lat:
                ((tick * tick * tick) * this.start.latLng.lat()) +
                (3 * ((1 - tick) * tick * tick) * cp1.lat) +
                (3 * ((1 - tick) * (1 - tick) * tick) * cp2.lat) +
                (((1 - tick) * (1 - tick) * (1 - tick)) * this.end.latLng.lat()),
              lng:
                (tick * tick * tick * this.start.latLng.lng()) +
                (3 * ((1 - tick) * tick * tick) * cp1.lng) +
                (3 * ((1 - tick) * (1 - tick) * tick) * cp2.lng) +
                (((1 - tick) * (1 - tick) * (1 - tick)) * this.end.latLng.lng()),
            };
          });
      }
      return false;
    },
  },
  watch: {
    markersgenerate(markersgenerate) {
      if (markersgenerate.length > 2) {
        const bounds = new this.google.maps.LatLngBounds();
        markersgenerate.forEach((m) => {
          bounds.extend(m.latLng);
        });
        this.$refs.map.fitBounds(bounds);
      }
    },
  },
  methods: {
    setPlace(place) {
      this.place = place;
      this.autocompleteLat = this.place.geometry.location.lat();
      this.autocompleteLng = this.place.geometry.location.lng();
      this.autocompleteZoom = 15;
    },
    clicked(e) {
      if (!this.start && !this.end) {
        this.start = {
          latLng: e.latLng,
        };
      } else if (this.start && !this.end) {
        this.end = {
          latLng: e.latLng,
        };
      } else {
        this.start = {
          latLng: e.latLng,
        };
        this.end = null;
      }
    },
    generate() {
      const spread = Math.random() + 0.001;
      this.center = {
        lat: 1.38 + ((Math.random() - 0.5) * spread),
        lng: 103.8 + ((Math.random() - 0.5) * spread),
      };
      this.markersgenerate = range(30)
        .map(() => ({
          latLng: {
            lat: this.center.lat + ((Math.random() - 0.5) * spread),
            lng: this.center.lng + ((Math.random() - 0.5) * spread),
          },
        }));
    },
    usePlace() {
      if (this.place) {
        this.markers.push({
          position: {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng(),
          },
        });
        this.place = null;
      }
    },
  },
};
</script>
